export { default } from './MyBalancePay';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/MyBalance/MyBalancePay/index.js